import { combineReducers } from 'redux';
import * as actions from '../actions/index';
import { generateReducers } from 'redux-crud-resources';
import _ from 'underscore';
import { CRUDABLE_RESOURCES } from '../constants';

const miscReducers = {
  sessionsById: (state = null, action) => {
    switch (action.type) {
      case actions.GET_ALL_SESSIONS_SUCCESS:
        return _.indexBy(action.sessions, 'id');
      default:
        return state;
    }
  },
  loadingSessions: (state = null, action) => {
    switch (action.type) {
      case actions.GET_ALL_SESSIONS:
        return action.promise;
      case actions.GET_ALL_SESSIONS_SUCCESS:
        return null;
      default:
        return state;
    }
  },
};

const rootReducer = combineReducers({
  ...generateReducers(CRUDABLE_RESOURCES, actions),
  ...miscReducers,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/js/GameDay/reducers/index.js